var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.evaluator_view && !_vm.evaluatee_view && !_vm.preview_evaluation)?_c('div',{staticClass:"noprint"},[_c('div',[(
        _vm.test.is_valid == true &&
        _vm.test.evaluative_agent != null &&
        _vm.test.evaluation_situation != null
      )?_c('div',{class:{
        'alert alert-success': _vm.test.manual_is_valid == true,
        'alert alert-info': _vm.test.manual_is_valid == false,
      }},[_c('div',{staticClass:"d-flex justify-content-center"},[(_vm.test.manual_is_valid == false)?_c('div',{staticClass:"align-content-center"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$getVisibleNames("evaluations2.test", false, "Instrumento"))+" ")]),_vm._v(" "+_vm._s(_vm.$t("evaluations.newEvaluations.readyToClose"))+" "),(_vm.evaluation && _vm.evaluation.scope == 1)?_c('InfoTooltip',{attrs:{"tooltip_text":_vm.$t('evaluations.newEvaluations.instrumentIsValid', {
                entity: _vm.$getVisibleNames(
                  'evaluations2.test',
                  false,
                  'Instrumento'
                ),
              })}}):_vm._e(),(_vm.evaluation && _vm.evaluation.scope == 3)?_c('InfoTooltip',{attrs:{"tooltip_text":_vm.$t(
                'evaluations.newEvaluations.closingInstrumentAllowsActions',
                {
                  entity: _vm.$getVisibleNames(
                    'evaluations2.test',
                    false,
                    'Instrumento'
                  ),
                }
              )}}):_vm._e()],1):_vm._e(),(_vm.test.manual_is_valid == true)?_c('div',{staticClass:"align-content-center"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$getVisibleNames("evaluations2.test", false, "Instrumento"))+" ")]),_vm._v(" "+_vm._s(_vm.$t("evaluations.newEvaluations.closed"))+" ")]):_vm._e(),(_vm.allows_crud && _vm.test.manual_is_valid == false)?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.$t('evaluations.newEvaluations.pressToCloseInstrument', {
              entity: _vm.$getVisibleNames(
                'evaluations2.test',
                false,
                'Instrumento'
              ),
            }),"text_button":``,"click_button":_vm.changeStateManualIsValid,"icon":'unlock',"variant":'warning',"custom_class":`ml-2`,"disabled_button":_vm.disabled_button}}):_vm._e(),(_vm.allows_crud && _vm.test.manual_is_valid == true)?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.$t('evaluations.newEvaluations.pressToReopenInstrument', {
              entity: _vm.$getVisibleNames(
                'evaluations2.test',
                false,
                'Instrumento'
              ),
            }),"text_button":``,"click_button":_vm.changeStateManualIsValid,"icon":'lock',"variant":'warning',"custom_class":`ml-2`,"disabled_button":_vm.disabled_button}}):_vm._e()],1)]):_vm._e()]),(
      _vm.test.is_valid[1] ||
      _vm.test.evaluative_agent == null ||
      _vm.test.evaluation_situation == null
    )?_c('div',{staticClass:"alert alert-danger"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"align-content-center"},[_c('strong',[_vm._v(_vm._s(_vm.$t("evaluations.newEvaluations.problemsFound")))])]),_c('ButtonMedium',{attrs:{"tooltip_text":_vm.$t('evaluations.newEvaluations.pressToViewErrors'),"text_button":``,"click_button":() =>
            _vm.$bvModal.show(
              `modal-close-instrument-${_vm.test.id}-${_vm.container_instrument_id}`
            ),"icon":'exclamation',"variant":'danger',"custom_class":`ml-2`}})],1)]):_vm._e(),_c('b-modal',{attrs:{"id":`modal-close-instrument-${_vm.test.id}-${_vm.container_instrument_id}`,"title":_vm.$t('evaluations.newEvaluations.informationOf', {
        entity: _vm.$getVisibleNames('evaluations2.test', false, 'Instrumento'),
      }),"hide-footer":"","size":"xl"}},[_c('InfoTestTable',{attrs:{"test":_vm.test}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }